import PropTypes from 'prop-types';

export default PropTypes.shape({
  text: PropTypes.string,
  url: PropTypes.shape({
    primary: PropTypes.string,
  }),
});
